// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3_FkL","tab":"ProcedureTabs_tab__1D-CX"};